import styled from 'styled-components'

export const CategoryTitle = styled.h1`
  color: #9bf2d6;
  margin: 60px 40px 0 20px;
`
